module.exports = __webpack_public_path__ + "static/media/hull_color_style_0007.f9025033.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/hull_color_style_0007.jpg
// module id = 625
// module chunks = 0